import {Tag} from 'antd';

import {Locale} from '../../../../provider/locale/locale';
import {
    aiMonitoringRunStatusColorMap,
    aiMonitoringRunStatusLangKeyMap,
} from '../../../../service/ai-brand-monitoring/ai-brand-monitoring-const';
import {AiMonitoringRunStatusEnum} from '../../../../service/ai-brand-monitoring/ai-brand-monitoring-type';

type PropsType = {
    status: AiMonitoringRunStatusEnum;
};

// antd Tag showing a run's status with its color + localized label (shared by the dashboard
// in-progress card and the brand-analysis hero).
export function AiMonitoringRunStatusTag(props: PropsType): JSX.Element {
    const {status} = props;

    return (
        <Tag color={aiMonitoringRunStatusColorMap[status]}>
            <Locale stringKey={aiMonitoringRunStatusLangKeyMap[status]} />
        </Tag>
    );
}
